import {css} from 'styled-components';
import sfTextRegular from '../assets/fonts/SF-Pro-Text-Regular.otf';
import sfTextBold from '../assets/fonts/SF-Pro-Text-Bold.otf';

const fontFamilySF = 'SF';

export default css`
  @font-face {
    src: url(${sfTextBold});
    font-family: ${fontFamilySF};
    font-weight: bold;
  }
  
  @font-face {
    src: url(${sfTextRegular});
    font-family: ${fontFamilySF};
  }
`;



// WEBPACK FOOTER //
// ./src/styles/fonts.js